import { Sidebar } from "flowbite-react";
import { HiPlusCircle, } from "react-icons/hi";
import { FaClipboardList } from "react-icons/fa";
import { MdOutlineLiveTv } from "react-icons/md";
import { BsRobot } from "react-icons/bs";
import { Logout } from "../../Icons/Icons";
import { useLocation } from "react-router-dom";
import { getCookie } from "../../reducer/utils";
import { useState, useEffect } from "react";

function removeCookie(key) {
    console.log('key:', key);
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function Sidemenu({ style }) {
    const {pathname} = useLocation();
    const [roles, setRoles] = useState(null);

    const checkRole = (role) => {
        return roles && roles.includes(role);
    };

    useEffect(() => {
        const userRoles = getCookie('roles');
        setRoles(userRoles);
    }, []);

    return (
        <Sidebar className="h-screen bg-white whiteSidebar" style={{ style }}>
            <div className="flex items-center justify-center mt-2">
                <img src="/assets/svg/logo.svg" alt="" className="min-w-36"/>
            </div>
            <Sidebar.Items className="mt-5">
                <Sidebar.ItemGroup>
                    <Sidebar.Item icon={FaClipboardList} href="/dashboard" className={pathname === '/dashboard' && 'bg-gray-100'}>
                        VOD Requests
                    </Sidebar.Item>
                    <Sidebar.Collapse icon={MdOutlineLiveTv} label="Live OTT" className={(pathname === '/live-ott/category' || pathname === '/live-ott/event' || pathname === '/live-ott/analytics') && 'bg-gray-100'}>
                        <Sidebar.Item href="/live-ott/category" className={pathname === '/live-ott/category' && 'bg-gray-100'}>
                            Category
                        </Sidebar.Item>
                        <Sidebar.Item href="/live-ott/event" className={pathname === '/live-ott/event' && 'bg-gray-100'}>
                            Event
                        </Sidebar.Item>
                        {checkRole("internal") && (
                            <Sidebar.Item href="/live-ott/analytics" className={pathname === '/live-ott/analytics' && 'bg-gray-100'}>
                                Analytics
                            </Sidebar.Item>
                        )}
                    </Sidebar.Collapse>
                    <Sidebar.Collapse icon={BsRobot} label="Future Originals" className={(pathname === '/future-originals' || pathname === '/future-originals/analytics') && 'bg-gray-100'}>
                        <Sidebar.Item href="/future-originals" className={pathname === '/future-originals' && 'bg-gray-100'}>
                            Future Originals
                        </Sidebar.Item>
                        {checkRole("internal") && (
                            <Sidebar.Item href="/future-originals/analytics" className={pathname === '/future-originals/analytics' && 'bg-gray-100'}>
                                Analytics
                            </Sidebar.Item>
                        )}
                    </Sidebar.Collapse>
                    <div className="flex items-center justify-start absolute left-2 bottom-2" onClick={() => removeCookie('token')}>
                        <Sidebar.Item href="/priority" icon={Logout}>
                            Sign-out
                        </Sidebar.Item>
                    </div>
                </Sidebar.ItemGroup>
            </Sidebar.Items>
        </Sidebar>
    );
}
